import { useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Breadcrumbs, Button, LayerCard } from '@cloudflare/kumo'
import { HouseIcon } from '@phosphor-icons/react'
import type { RoomBookingDto } from '@hub-wifi/shared'
import { useTranslation } from '../i18n'
import { PageHeader } from '../components/kumo/page-header/page-header'
import { BookingFormCore } from '../components/booking-form/booking-form-core'

export function BookRoomPage() {
  const { bookingId } = useParams<{ bookingId?: string }>()
  const isEdit = Boolean(bookingId)
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [created, setCreated] = useState<RoomBookingDto | null>(null)

  if (created) {
    return (
      <div>
        <PageHeader
          breadcrumbs={
            <Breadcrumbs>
              <Breadcrumbs.Link icon={<HouseIcon size={14} />} href="/">
                {t('nav.home')}
              </Breadcrumbs.Link>
              <Breadcrumbs.Separator />
              <Breadcrumbs.Link href="/my/bookings">{t('myBookings.title')}</Breadcrumbs.Link>
              <Breadcrumbs.Separator />
              <Breadcrumbs.Current>{t('myBookings.confirmed')}</Breadcrumbs.Current>
            </Breadcrumbs>
          }
          title={t('myBookings.confirmed')}
        />
        <LayerCard>
          <LayerCard.Primary>
            <p className="mb-3">
              <strong>{created.roomName ?? created.roomId}</strong> —{' '}
              {new Date(created.startAt).toLocaleString()}
            </p>
            <div className="flex gap-2 pt-1">
              <Button variant="secondary" onClick={() => navigate('/my/bookings')}>
                {t('myBookings.backToList')}
              </Button>
              <Link to={`/my/guests/new?roomBookingId=${created.id}`}>
                <Button variant="primary">{t('myBookings.inviteGuestForBooking')}</Button>
              </Link>
            </div>
          </LayerCard.Primary>
        </LayerCard>
      </div>
    )
  }

  return (
    <div>
      <PageHeader
        breadcrumbs={
          <Breadcrumbs>
            <Breadcrumbs.Link icon={<HouseIcon size={14} />} href="/">
              {t('nav.home')}
            </Breadcrumbs.Link>
            <Breadcrumbs.Separator />
            <Breadcrumbs.Link href="/my/bookings">{t('myBookings.title')}</Breadcrumbs.Link>
            <Breadcrumbs.Separator />
            <Breadcrumbs.Current>
              {isEdit ? t('myBookings.reschedule') : t('myBookings.book')}
            </Breadcrumbs.Current>
          </Breadcrumbs>
        }
        title={isEdit ? t('myBookings.reschedule') : t('myBookings.book')}
        description={t('myBookings.bookPageDescription')}
      />

      <BookingFormCore
        bookingId={bookingId}
        scope={{ kind: 'self' }}
        onSuccess={setCreated}
        onCancel={() => navigate('/my/bookings')}
      />
    </div>
  )
}
